import React from 'react'
import { IconProps } from './types'

export const PageOcrIcon: React.FC<IconProps> = ({
  size = 24,
  strokeWidth = 2,
  primaryColor = 'currentColor',
  className,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={primaryColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
    <circle cx="12" cy="13.5" r="2.5" />
    <path d="M8 18.5c.67-1.33 2-3 4-3s3.33 1.67 4 3" />
    <path d="M14 21v-1.5" />
    <path d="M10 21v-1.5" />
  </svg>
)
